import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { salaryEntriesApi } from './salary-entries.api';
import { SalaryCommissionRowDto, SalaryEntryDto, SalaryPayOrderDto } from '@sr/dto';

export const useSalaryData = (year: number, month: number, userId: number) => {
  const { data, isLoading, error } = salaryEntriesApi.useGetSalaryEntriesQuery(
    { year, month, userId },
    { refetchOnMountOrArgChange: 120 }
  );

  return {
    rows: data ? data : [] as SalaryEntryDto[],
    error: extractNestJsErrorMessage(error),
    isLoading,
  };
};
export const useSalaryCommission = (year: number, month: number, userId: number) => {
  const { data, isLoading, error } = salaryEntriesApi.useGetSalaryCommissionQuery(
    { year, month, userId },
    { refetchOnMountOrArgChange: 120 }
  );

  return {
    rows: data ? data : [] as SalaryCommissionRowDto[],
    error: extractNestJsErrorMessage(error),
    isLoading,
  };
};
export const useSummary = (year: number, month: number) => {
  const { data, isLoading, error } = salaryEntriesApi.useGetSummaryQuery(
    { year, month },
    { refetchOnMountOrArgChange: 120 }
  );

  return {
    rows: data ? data : [],
    error: extractNestJsErrorMessage(error),
    isLoading,
  };
};
export const usePremiumFund = (year: number, month: number, managerId: number) => {
  const { data, isLoading, error } = salaryEntriesApi.useGetPremiumFundQuery(
    { year, month, managerId },
    { refetchOnMountOrArgChange: 60 }
  );

  return {
    rows: data ? data : [],
    error: extractNestJsErrorMessage(error),
    isLoading: isLoading,
  };
};

export const useDeleteSalaryEntry = (year: number, month: number, userId: number) => {
  const [callDelete] =  salaryEntriesApi.useDeleteSalaryEntryMutation();
  return (entryId: number)=>{
    return callDelete({ year, month, userId, entryId }).unwrap();
  };
};

export const usePayOrderSalaryData = (
  year: number,
  month: number,
  userId: number
): {
  collection: SalaryPayOrderDto | undefined;
  error: string | null;
  isLoading: boolean;
} => {
  const { currentData, isFetching, error } = salaryEntriesApi.useGetPayOrderSalaryQuery(
    { year, month, userId },
    { refetchOnMountOrArgChange: 120 }
  );

  return {
    collection: currentData,
    error: extractNestJsErrorMessage(error),
    isLoading: isFetching,
  };
};

export const usePercentageSupervisor = (year: number, month: number) => {
  const { data, isLoading, error } = salaryEntriesApi.useGetPercentageSupervisorQuery(
    { year, month },
    { refetchOnMountOrArgChange: 60 }
  );

  return {
    rows: data ? data : [],
    error: extractNestJsErrorMessage(error),
    isLoading: isLoading,
  };
};
